import { render, staticRenderFns } from "./GameStatus.vue?vue&type=template&id=438d6e18&scoped=true"
import script from "./GameStatus.vue?vue&type=script&lang=js"
export * from "./GameStatus.vue?vue&type=script&lang=js"
import style0 from "./GameStatus.vue?vue&type=style&index=0&id=438d6e18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438d6e18",
  null
  
)

export default component.exports